import { AssetDto, AssetVersionDto } from '@nusign/picflow-backend-types';
import { resizedImageDownloadFormatMap } from '../../consts';
import { calcBaseUrl } from '../../lib/calc-base-url';
import { calcResizedUrl } from '../../lib/calc-resized-url';
import { openFile } from '../../lib/download-file';
import { isImagesBucketAsset } from '../../lib/is-images-bucket-asset';

export const getDownloadUrl = (
  asset: AssetDto,
  assetVersion: AssetVersionDto,
  size: number,
  assetsEndpoint: string,
  watermark: boolean
) => {
  const assetType = asset.type;
  let width = assetVersion.data?.width || 0;
  let height = assetVersion.data?.height || 0;

  if (size) {
    const aspect = height / width;
    width = size;
    height = Math.round(size * aspect);
  }

  const original = !size;
  if (original) {
    if (assetType === 'image' && isImagesBucketAsset(asset, assetVersion)) {
      return `${assetsEndpoint}/images/${assetVersion.original_key}`;
    }
    if (assetType === 'video') {
      return `${assetsEndpoint}/videos/${assetVersion.original_key}`;
    }
    return `${assetsEndpoint}/assets/${assetVersion.original_key}`;
  }

  const extension = assetVersion.asset_name.split('.').pop().toLowerCase();
  const newExtension = resizedImageDownloadFormatMap[extension] || 'jpg';
  if (width >= assetVersion.data.width && (newExtension === 'jpg' || newExtension === 'webp')) {
    return calcBaseUrl(assetsEndpoint, asset, assetVersion, watermark);
  }
  return calcResizedUrl(assetsEndpoint, asset, assetVersion, `l${size}mi`, watermark, false, newExtension);
};

export const downloadAsset = async (
  asset: AssetDto,
  assetVersion: AssetVersionDto,
  longEdge: number,
  assetsEndpoint: string,
  watermark: boolean
) => {
  const url = getDownloadUrl(asset, assetVersion, longEdge, assetsEndpoint, watermark);
  const urlExtension = url.split('.').pop().split('?')[0];

  let name = assetVersion.asset_name;
  if (longEdge) {
    const nameParts = assetVersion.asset_name.split('.');
    nameParts.pop();
    name = `${nameParts.join('.')}.${urlExtension}`;
  }

  openFile(url + `?download=${encodeURIComponent(name)}`, name);
};
